import { RedirectToSignin } from './RedirectToSignin';
import { connect } from 'react-redux';
import { signInActions } from 'src/store/modules/signin';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout())
});

export const pureComponent = RedirectToSignin;
export default connect(null, mapDispatchToProps)(RedirectToSignin);

interface IDispatchFromProps {
  signout(): void;
}
